/* tslint:disable */
/* eslint-disable */
export enum SmtpSecurity {
  None = 0,
  Auto = 1,
  SslOnConnect = 2,
  StartTls = 3,
  StartTlsWhenAvailable = 4
}
